// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "04527ad9a368";
export const BUILD_VERSION_NUMBER = 30;
